






































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import RadioBox from '@/shared/components/RadioBox/RadioBox.vue';
import LoadingBlock from '@/shared/components/LoadingBlock/LoadingBlock.vue';

import { ICheckout } from '@/interfaces/Checkout';

const CheckoutModule = namespace('App/Checkout');

@Component({
  components: {
    RadioBox,
    LoadingBlock,
  }
})
export default class PlanLoading extends Vue {
  @CheckoutModule.State(state => state.checkout)
  private checkout: ICheckout;

  private get subtitle(): string|null|undefined {
    return this.checkout.cart.offer
      && this.checkout.cart.offer.subtitle;
  }

  private get intervalType(): string|null|undefined {
    return this.checkout.cart.offer
      && this.checkout.cart.offer.interval_type;
  }

  get intervalTypeName(): string {
    if (!this.intervalType) return '';
    const tPlan = this.$t('App.Checkout.plan');
    const tIntervalType = this.$t(
      `App.Checkout.intervalType.${this.intervalType}`
    );
    return `${tPlan} ${tIntervalType}`;
  }
}
